import React from "react";

/**
 * Lightweight loading placeholder shown while the file list (or the auth
 * check) is in flight, so the page never jumps straight from blank to
 * content/empty-state.
 */
export const FilesGridSkeleton: React.FC = () => {
  return (
    <div
      data-testid="my-files-skeleton"
      style={{
        display: "grid",
        // Track sizing must match FileGrid exactly, or the grid jumps sideways
        // when the real cards replace the placeholders.
        gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
        gap: "1.25rem",
        padding: "1.5rem 2rem 2rem",
      }}
    >
      {Array.from({ length: 6 }).map((_, i) => (
        <div
          key={i}
          style={{
            aspectRatio: "8 / 6",
            borderRadius: "0.75rem",
            background:
              "linear-gradient(90deg, var(--mf-skeleton-from) 25%, var(--mf-skeleton-to) 37%, var(--mf-skeleton-from) 63%)",
            backgroundSize: "400% 100%",
            animation: "my-files-skeleton-pulse 1.4s ease infinite",
          }}
        />
      ))}
      <style>
        {`@keyframes my-files-skeleton-pulse {
          0% { background-position: 100% 50%; }
          100% { background-position: 0 50%; }
        }`}
      </style>
    </div>
  );
};

export default FilesGridSkeleton;
